import React from 'react';

import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export default function Header({
  hasUserBlock,
  hasSearch,
  searchInput,
  setSearchInput,
  searchDisabled,
  trainingPathPlaylist,
  searchPlaceholder,
}) {
  const isMobile = useCheckMobileScreen();

  return isMobile ? (
    <MobileHeader
      hasUserBlock={hasUserBlock}
      hasSearch={hasSearch}
      searchInput={searchInput}
      setSearchInput={setSearchInput}
      searchDisabled={searchDisabled}
      trainingPathPlaylist={trainingPathPlaylist}
      searchPlaceholder={searchPlaceholder}
    />
  ) : (
    <DesktopHeader
      hasUserBlock={hasUserBlock}
      hasSearch={hasSearch}
      searchInput={searchInput}
      setSearchInput={setSearchInput}
      searchDisabled={searchDisabled}
      trainingPathPlaylist={trainingPathPlaylist}
      searchPlaceholder={searchPlaceholder}
    />
  );
}
